export const MAX_SIZE_REVIEWS = 10;